import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

export default function Footer() {
    const settings = useSettings();
    return (
        <footer className="bg-nocturne-card border-t border-nocturne-border">
            <div className="max-w-7xl mx-auto px-6 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
                <div>
                    <div className="text-xl font-bold text-white tracking-wide mb-1">
                        {settings.logo ? (
                            <img src={settings.logo} alt="Logo" className="h-6 w-auto object-contain mb-2" />
                        ) : (
                            'AMISUBSOLUTIONS'
                        )}
                    </div>
                    <p className="text-nocturne-muted text-xs">Architecting the future of digital experience with neon precision.</p>
                    <div className="mt-4 text-nocturne-muted text-[10px] space-y-1">
                        <p>{settings.address}</p>
                        <p>{settings.phone} | {settings.email}</p>
                    </div>
                </div>
                <div className="flex items-center gap-6 text-nocturne-muted text-xs">
                    <Link to="/privacy-policy" className="hover:text-nocturne-purple transition-colors">Privacy Policy</Link>
                    <Link to="/terms-of-service" className="hover:text-nocturne-purple transition-colors">Terms of Service</Link>
                    <span className="text-nocturne-border">|</span>
                    <span>© 2025 Amisubsolutions. All rights reserved.</span>
                </div>
            </div>
        </footer>
    );
}
